<template>
    <!-- PC 端 -->
    <div v-if="!mobile" class="list-item">
        <div v-if="!item.history && item.imageType !== 1" class="lg:j-w-280 lg:j-h-186 bg-#FAFAFA">
            <img class="lazyload lg:j-w-280 lg:j-h-186 object-contain" :data-src="item.image" alt="" />
        </div>
        <template v-else>
            <div class="history" :class="[item.imageType === 1 ? '!p-0' : '']">
                <div
                    class="contain"
                    :class="[item.imageType === 1 ? '!w-[90%]' : '']"
                    :style="
                        item.imageType === 1
                            ? `background: url(${item.image}) center center /contain no-repeat;`
                            : `background: url('https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/ead6f1d359da789814cd78421b6956bb.png?v=1686109159') center center /contain no-repeat`
                    "
                >
                    <div v-if="item.imageType !== 1" class="off">{{ item.off }}</div>
                    <div
                        class="value"
                        :class="[isJP() ? 'lg:j-text-44' : 'lg:j-text-36']"
                        :style="item.imageType === 1 ? 'color:#FE7704;margin-right:25%;white-space:nowrap;' : ''"
                    >
                        {{ item.rightValue }}
                        <span v-if="item.imageType === 1" class="lg:a-text-12 -lg:j-ml-4">{{item.off}}</span>
                    </div>
                </div>
            </div>
        </template>

        <div class="list-item-content">
            <!-- 无折扣码 -->
            <template v-if="!item.discountCode">
                <h2
                    v-if="props.type !== 'Products'"
                    class="text-sub Poppins-SemiBold font-semibold lg:j-text-24 lg:j-leading-26 lg:j-mb-40"
                >{{ item.pointValue }} {{ t('member_index.common.points') }}</h2>
                <!-- Products -->
                <div v-else>
                    <h2
                        class="lg:j-text-18 lg:j-leading-26 lg:j-h-52 Poppins-SemiBold font-semibold text-sub line-clamp-2"
                        :title="item.goodsTitle"
                    >{{ item.goodsTitle }}</h2>
                    <p class="lg:j-text-18 lg:j-leading-26 lg:j-h-26 Poppins-Regular font-normal text-#808080 lg:j-mt-10 lg:j-mb-15">
                        {{ item.currencyTypePrefix === '€' ? `${item.goodsPrice} ${item.currencyTypePrefix}` : `${item.currencyTypePrefix} ${item.goodsPrice}` }}
                    </p>
                    <p class="inline-block lg:j-border-1 border-solid border-primary lg:j-text-16 lg:j-leading-16 lg:j-p-6 lg:j-rounded-5 text-primary lg:j-mb-15 Poppins-Regular font-normal">
                        {{ item.pointValue }} {{ t('member_index.common.points') }}
                    </p>
                </div>
            </template>

            <!-- 有折扣码 -->
            <template v-else>
                <h2
                    v-if="props.type === 'Products'"
                    class="lg:j-text-18 lg:j-leading-26 lg:j-h-52 Poppins-SemiBold font-semibold line-clamp-2"
                    :title="item.goodsTitle"
                >{{ item.goodsTitle }}</h2>
                <p class="text-black lg:j-text-18 Poppins-SemiBold font-semibold lg:j-mt-10 lg:j-mb-15">
                    <span v-if="props.type !== 'VirtualCard'">{{ t('member_index.redeem_points.code') }}: {{ item.discountCode }}</span>
                </p>
            </template>

            <!-- 按钮 -->
            <p class="w-full flex items-center justify-between" :class="[(isDEOrJP() && props.isModal) ? 'flex-col !items-start' : '']">
                <template v-if="!item.outStockFlag">
                    <template v-if="!item.discountCode">
                        <span
                            class="text-btn"
                            :class="[props.isLogin && !item.pointEnough ? '!text-disable !hover:text-disable !cursor-default' : '']"
                            @click="showModal('Redeem', item)"
                        >{{ t('member_index.common.redeem') }} &gt;</span>
                    </template>
                    <template v-else>
                        <span
                            v-if="props.type !== 'VirtualCard'"
                            class="text-btn"
                            @click.prevent="copy(item)"
                        >{{ t('member_index.redeem_points.copy_and_use') }}</span>
                    </template>
                </template>
                <template v-else>
                    <span class="text-btn !text-disable !hover:text-disable !cursor-default">{{ t('member_index.common.outOfStock') }}</span>
                </template>
                <span class="rules-btn" @click="showModal('Rules', item)">{{ t('member_index.common.rules') }}</span>
            </p>
        </div>

        <div :class="['count-down', `count-down__${item.ruleId}`]" v-if="item.showCountDown !== 0 && !item.discountCode">
            <div class="count-down__item" :style="{ '--countdown-text-color': item.countDownColor }">
                <span :style="{color: item.countDownDescColor, textAlign: 'center'}">{{ item.countDownDesc }}</span>
                <a-statistic-countdown
                    format="DD : HH : mm : ss"
                    :value="item.countDownEndTime"
                    @finish="onFinish(item)"
                />
            </div>
        </div>
    </div>

    <!-- 移动端 -->
    <template v-else>
        <!-- My Rewards -->
        <div v-if="props.isModal" class="w-full h-full modal___s_item">
            <div class="list-item w-320 h-full">
                <div v-if="!item.history && item.imageType !== 1" class="w-full h-220 bg-#FAFAFA">
                    <img class="lazyload w-full h-220 object-contain" :data-src="item.image" alt="" />
                </div>
                <template v-else>
                    <div class="history" :class="[item.imageType === 1 ? '!p-0' : '']">
                        <div
                            class="contain"
                            :class="[item.imageType === 1 ? '!w-[90%]' : '']"
                            :style="
                                item.imageType === 1
                                    ? `background: url(${item.image}) center center /contain no-repeat;`
                                    : `background: url('https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/ead6f1d359da789814cd78421b6956bb.png?v=1686109159') center center /contain no-repeat`
                            "
                        >
                            <div v-if="item.imageType !== 1" class="off">{{ item.off }}</div>
                            <div
                                class="value"
                                :class="[isJP() ? 'text-30' : 'text-40']"
                                :style="item.imageType === 1 ? 'color:#FE7704;margin-right:25%;white-space:nowrap;' : ''"
                            >
                                {{ item.rightValue }}
                                <span v-if="item.imageType === 1" class="text-24">{{item.off}}</span>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="list-item-content">
                    <!-- 折扣码 判断 -->
                    <template v-if="!item.discountCode">
                        <h2
                            v-if="props.type !== 'Products'"
                            class="text-32 leading-36 lg:j-text-24 lg:j-leading-26 text-sub Poppins-SemiBold font-semibold lg:j-mb-40"
                        >{{ item.pointValue }} {{ t('member_index.common.points') }}</h2>
                        <!-- Products -->
                        <div v-else>
                            <h2
                                class="text-28 leading-36 h-72 Poppins-SemiBold font-semibold text-sub line-clamp-2 lg:(j-text-18 j-leading-26 j-h-52)">
                                {{ item.goodsTitle }}</h2>
                            <p class="text-28 leading-36 h-36 my-15 Poppins-Regular font-normal text-#808080 lg:(j-text-18 j-leading-26 j-mt-10 j-mb-15)">
                                {{ item.currencyTypePrefix === '€' ? `${item.goodsPrice} ${item.currencyTypePrefix}` : `${item.currencyTypePrefix} ${item.goodsPrice}` }}
                            </p>
                            <p
                                class="inline-block border-3 border-solid border-primary text-primary Poppins-Regular font-normal text-22 px-16 py-4 rounded-8 mb-30 lg:(j-border-1 j-text-16 j-leading-16 j-p-6 j-rounded-5 j-mb-15)">
                                {{ item.pointValue }} {{ t('member_index.common.points') }}</p>
                        </div>
                    </template>
                    <template v-else>
                        <h2
                            v-if="props.type === 'Products'"
                            class="text-28 leading-36 Poppins-SemiBold font-semibold line-clamp-2 lg:(j-text-18 j-leading-26)"
                        >{{ item.goodsTitle }}</h2>
                        <p class="text-black text-20 my-15 Poppins-SemiBold font-semibold">
                            <span
                                v-if="props.type !== 'VirtualCard'"
                            >{{ t('member_index.redeem_points.code') }}: {{ item.discountCode }}</span>
                        </p>
                    </template>

                    <!-- 按钮 -->
                    <p class="w-full flex items-center justify-between"
                        :class="[(isDEOrJP() && props.isModal) ? 'flex-col !items-start ' : '']">
                        <template v-if="!item.outStockFlag">
                            <template v-if="!item.discountCode">
                                <span
                                    class="text-28 Poppins-Bold font-bold text-primary !p-0"
                                    :class="[props.isLogin && !item.pointEnough ? '!text-disable !hover:text-disable !cursor-not-allowed' : '']"
                                    @click="showModal('Redeem', item)"
                                >{{ t('member_index.common.redeem') }} &gt;</span>
                            </template>
                            <template v-else>
                                <span
                                    v-if="props.type !== 'VirtualCard'"
                                    class="text-btn"
                                    @click.prevent="copy(item)"
                                >{{ t('member_index.redeem_points.copy_and_use') }}</span>
                            </template>
                        </template>
                        <template v-else>
                            <span class="text-24 text-[#c6c6c6] max-w-200 leading-24 !p-0 !text-disable !hover:text-disable !cursor-not-allowed"
                            >{{ t('member_index.common.outOfStock') }}</span>
                        </template>
                        

                        <span class="rules-btn" @click="showModal('Rules', item)">{{ t('member_index.common.rules'
                        ) }}</span>
                    </p>
                </div>

                    <div :class="['count-down', `count-down__${item.ruleId}`]" v-if="item.showCountDown !== 0 && !item.discountCode">
                        <div class="count-down__item" :style="{ '--countdown-text-color': item.countDownColor }">
                            <span :style="{color: item.countDownDescColor, textAlign: 'center'}">{{ item.countDownDesc }}</span>
                            <a-statistic-countdown
                                format="DD : HH : mm : ss"
                                :value="item.countDownEndTime"
                                @finish="onFinish(item)" 
                            />
                        </div>
                    </div>
            </div>
        </div>

        <div v-else class="w-full flex justify-between items-start" :class="{ 'flex-between': length <= 2 }" style="flex-wrap: wrap;">
            <div 
                class="list-item w-335 mb-20"
                v-for="(it) in item"
            >
                <div class="w-full h-220 bg-#FAFAFA">
                    <img class="lazyload w-full h-220 object-contain" :data-src="it.image" alt=""/>
                </div>
                <div class="list-item-content rounded-b-[16px]">
                    <!-- 折扣码 判断 -->
                    <template v-if="!it.discountCode">
                        <h2 v-if="props.type !== 'Products'"
                            class="text-32 leading-36 lg:j-text-24 lg:j-leading-26 text-sub Poppins-SemiBold font-semibold lg:j-mb-40">
                            {{ it.pointValue }} {{ t('member_index.common.points') }}</h2>
                        <!-- Products -->
                        <div v-else>
                            <h2
                                class="text-28 leading-36 h-72 Poppins-SemiBold font-semibold text-sub line-clamp-2 lg:(j-text-18 j-leading-26 j-h-52)">
                                {{ it.goodsTitle }}</h2>
                            <p class="text-28 leading-36 h-44 my-15 Poppins-Regular font-normal text-#808080 lg:(j-text-18 j-leading-26 j-mt-10 j-mb-15)">
                                {{ it.currencyTypePrefix === '€' ? `${it.goodsPrice} ${it.currencyTypePrefix}` : `${it.currencyTypePrefix} ${it.goodsPrice}` }}
                            </p>
                            <p
                                class="inline-block border-3 border-solid border-primary text-primary Poppins-Regular font-normal text-22 px-16 py-4 rounded-8 mb-30 lg:(j-border-1 j-text-16 j-leading-16 j-p-6 j-rounded-5 j-mb-15)">
                                {{ it.pointValue }} {{ t('member_index.common.points') }}</p>
                        </div>
                    </template>
                    <template v-else>
                        <h2 v-if="props.type === 'Products'"
                            class="text-28 leading-36 Poppins-SemiBold font-semibold line-clamp-2 lg:(j-text-18 j-leading-26)">
                            {{ it.goodsTitle }}</h2>
                        <p class="text-black text-20 Poppins-SemiBold font-semibold">
                            <span v-if="props.type !== 'VirtualCard'">{{ t('member_index.redeem_points.code') }}: {{
                                it.discountCode }}</span>
                        </p>
                    </template>

                    <!-- 按钮 -->
                    <p class="w-full flex items-end justify-between">
                        <template v-if="!it.outStockFlag">
                            <template v-if="!it.discountCode">
                                <span class="text-24 Poppins-Bold font-bold text-primary !p-0"
                                    :class="[!it.pointEnough ? '!text-disable !hover:text-disable !cursor-not-allowed' : '']"
                                    @click="showModal('Redeem', it)">{{ t('member_index.common.redeem') }} &gt;</span>
                            </template>
                            <template v-else>
                                <span v-if="props.type !== 'VirtualCard'" class="text-btn" @click.prevent="copy(it)">{{
                                    t('member_index.redeem_points.copy_and_use') }}</span>
                            </template>
                        </template>
                        <template v-else>
                            <span class="text-24 text-[#c6c6c6] max-w-200 leading-24 !p-0 "
                            >{{ t('member_index.common.outOfStock') }}</span>
                        </template>

                        <span class="rules-btn" @click="showModal('Rules', it)">{{ t('member_index.common.rules') }}</span>
                    </p>
                </div>

                    <div :class="['count-down', `count-down__${it.ruleId}`]" v-if="it.showCountDown !== 0 && !props.isModal">
                        <div class="count-down__item" :style="{ '--countdown-text-color': it.countDownColor }">
                            <span :style="{color: it.countDownDescColor, textAlign: 'center'}">{{ it.countDownDesc }}</span>
                            <a-statistic-countdown
                                format="DD : HH : mm : ss"
                                :value="it.countDownEndTime"
                                @finish="onFinish(it)" 
                            />
                        </div>
                    </div>
            </div>
        </div>
    </template>

    <SwiperCardItemModal ref="cardItemModal" :isLogin="props.isLogin" :type="props.type" />
</template>
<script setup>
import SwiperCardItemModal from './SwiperCardItemModal.vue'
import { message } from 'ant-design-vue'
import { copyText, cookie, COLLECTION_LINK, uLogin } from '@u/common'
import { shopifyLogin } from "@a/userCommon";
import { useStore } from 'vuex';

const store = useStore();
const language = computed(() => store.getters.language);

import { reactive, onMounted } from "vue"
const count_status = reactive({})

const { t } = useI18n()

const props = defineProps({
    mobile: Boolean,
    item: Object | Array,
    type: String,
    length: Number,
    isLogin: Boolean,
    isModal: Boolean
})

const router = useRouter()

const cardItemModal = ref(null)
const showModal = (type, item) => {
    if (!props.isLogin) {
        if (type === 'Redeem') {
            if(window.jackeryLoginApp) {
                window.jackeryLoginApp.modalLogin({
                    return_url: `${window.location.origin}${window.location.pathname}`, 
                    register_act: 'MEM-Register'
                })     
            }
            return
        }
    } else {
        if (type === 'Redeem' && !item.pointEnough) {
            return
        }
    }

    cardItemModal.value?.openModal({
        cardType: type,
        cardDetail: item,
        cardRules: item.ruleInfo,
        isFinish: Array.isArray(props.item) ? count_status[item.ruleId] : count_status.isFinish
    })
};

const cr = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
const isDEOrJP = () => ['DE', 'JP'].includes(cr)
const isJP = () => ['JP'].includes(cr)

const SHOP_ID = cookie.get("_jk_shop_id") || localStorage.getItem('JACKERY_ID_SHOP_ID')
// 复制
const copy = async ({ discountCode, goodsDetailUrl, }) => {
    const data = await copyText(discountCode)
    if (data) {
        message.success(t('member_index.common.copy_successfully'));
        //日本临时活动
        if(data == "SwitchBot15"){
            let jpLink="https://www.switchbot.jp?utm_source=referral&utm_medium=jackery&utm_campaign=point"
            window.open(jpLink)
        }else if(data == "JAKW20"){
            let usLink="https://www.simpurelife.com"
            window.open(usLink)
        }else{
            const CR = cookie.get("_jk_cr") || localStorage.getItem('JACKERY_ID_CR') || 'US'
            // 产品 跳产品下单页，优惠券/礼品卡 跳转官网 Collection 页面
            const url = props.type === 'Products' ? goodsDetailUrl : `https://${language.value.current.domain}${COLLECTION_LINK[CR]}`
            setTimeout(() => {
                uLogin(shopifyLogin, SHOP_ID, url, true)
            }, 1500)
        } 
    }
}

const onFinish = (item) => {
    if(Array.isArray(props.item)) {
        count_status[item.ruleId] = true

        // FIX: SWIPER slide content高度变化会重新渲染内容
        document.querySelectorAll(`.count-down__${item.ruleId}`).forEach(i => {
            i.style.opacity = "0"
        })
    } else {
        count_status.isFinish = true
        document.querySelectorAll(`.count-down__${item.ruleId}`).forEach(i => {
            i.style.opacity = "0"
        })
    }
}

onMounted(() => {
    if(Array.isArray(props.item)) {
        props.item.forEach(item => {
            count_status[item.ruleId] = false
        })
        // swiper-wrapper
    } else {
        count_status.isFinish = false
    }
})

</script>
<style scoped>
.count-down {
    /* padding: 12px 0; */
    background: #F5F5F5;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
}
.ant-modal-content .count-down {
    background: transparent;
}

.count-down__item {
    padding: 8px;
    width: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    font-size: 12px;
    margin-top: 5px;
    color: var(--countdown-text-color);
}
.count-down__item_time {
    font-size: 13px;
    font-weight: bold;
    color: var(--countdown-text-color);
    padding-bottom: 0;
}
.count-down__item_des {
    font-size: 12px;
    font-weight: 400;
    color: rgba(0,0,0,0.5);
}
:deep(.ant-statistic-content) {
    /* line-height: 18px; */
    display: flex;
}
:deep(.ant-statistic-content-value) {
    font-size: 13px;
    font-weight: bold;
    color: var(--countdown-text-color);
    /* line-height: 18px; */
    min-width: 102px;
    padding-left: 8px;
    padding-right: 8px;
}

.list-item-content {
    border-radius: 0 0 0.8333333333333334vw 0.8333333333333334vw
}
@media screen and (max-width: 1024px) {
    .count-down {
        gap: 4px;
        background: transparent;
    }
    .count-down__item {
        padding: 2.13333333333333vw;
        font-size: 3.2vw;
        margin-top: 1.06666666666667vw;
    }
    .count-down__item_time {
        font-size: 3.2vw;
        line-height: 3.73333333333333vw;
    }
    .list-item-content {
        border-radius: 0 0 2.3333vw 2.33333vw
    }

    :deep(.ant-statistic-content) {
        line-height: 3.73333333333333vw;
    }
    :deep(.ant-statistic-content-value) {
        font-size: 3.2vw;
        line-height: 3.73333333333333vw;
        min-width: 25vw;
        padding-left: 2.13333333333333vw;
        padding-right: 2.13333333333333vw;
    }
    .modal___s_item .list-item-content {
        /* flex: 1!important; */
    }
}













.list-item {
    @apply min-h-360 rounded-16 flex flex-col overflow-hidden lg:(j-w-280 j-min-h-315 j-rounded-16)
}
.list-item-content {
    @apply p-30 flex items-start flex-col bg-white lg:(j-px-30 j-pt-30 j-pb-20)
}
.text-btn {
    @apply text-24 lg:j-text-14 lg:j-leading-26 Poppins-Bold font-bold text-primary !lg:j-p-0 lg:j-mr-30 hover:text-primary cursor-pointer
}
.rules-btn {
    @apply text-24 Poppins-Light font-normal text-#8C8C8C underline underline-offset-4 hover:text-primary hover:underline lg:j-text-14 lg:j-leading-26 cursor-pointer
}

.history {
    @apply
        w-full h-220 p-30 lg:j-w-280 lg:j-h-186 lg:j-p-40 flex-center bg-#F5F6F6
}
.contain {
    @apply
        w-full h-full flex-center color-white Poppins-Bold font-bold relative
}

.off {
    @apply absolute right-10 top-12 lg:j-right-10 lg:j-top-0 text-27 lg:j-text-16 Poppins-SemiBold
}

.value {
    @apply font-bold Poppins-Bold
}
</style>
